import { render, staticRenderFns } from "./ctx-head.vue?vue&type=template&id=e1527e14&scoped=true"
import script from "./ctx-head.vue?vue&type=script&lang=js"
export * from "./ctx-head.vue?vue&type=script&lang=js"
import style0 from "./ctx-head.vue?vue&type=style&index=0&id=e1527e14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1527e14",
  null
  
)

export default component.exports